import React from "react";
import { ListItemText } from "@mui/material";
import { NavElement } from "type/navigation/main_navigation.type";
import LinkTo from "components/navigation/link/LinkTo";

export type MainNavItemProps = {
  navImage?: React.ReactNode;
  navElement: NavElement;
};

/** Link component for main navigation */

export default function MainNavItem({ navElement }: MainNavItemProps) {
  if (!navElement) return null;

  return (
    <LinkTo to={navElement.path} key={navElement.path}>
      <ListItemText primary={navElement.title} />
    </LinkTo>
  );
}
